export class UnsupportedBrowserError extends Error {
  constructor() {
    super('unsupported browser');
  }
}
